module.exports = __webpack_public_path__ + "img/logo@2x.c8175cec.png";